export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Product Research & QC Hub",

  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.categories": "Categories",
  "nav.qc": "QC Photos",
  "nav.shipping": "Shipping",
  "nav.review": "Review",
  "nav.safety": "Safety",
  "nav.buyNow": "Buy It Now",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.da": "Dansk",
  "lang.de": "Deutsch",

  "hero.badge": "Independent Resource · Updated 2026",
  "hero.title": "AllChinaBuy Spreadsheet — Find Products, QC Photos & Better Buying Guides",
  "hero.subtitle": "Explore AllChinaBuy spreadsheets, product finds, QC information, shipping guides, warehouse tips, coupons and safety resources in one organized place.",
  "hero.ctaExplore": "AllChinaBuy Spreadsheet",
  "hero.ctaBuyNow": "Buy It Now",
  "hero.searchPlaceholder": "Search AllChinaBuy spreadsheet, products, QC or shipping...",
  "hero.dropdownLabel": "Browse Product Categories",
  "hero.noResults": "No categories found",

  "categories.title": "Popular Product Categories",
  "categories.subtitle": "Jump straight to any product category on the main AllChinaBuy spreadsheet site.",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants / Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear / Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",

  "what.title": "What Is an AllChinaBuy Spreadsheet?",
  "what.body": "An AllChinaBuy spreadsheet is a shared, organized sheet that collects product links, prices, sizes, QC photos and shipping notes for the items you want to buy through AllChinaBuy. Instead of juggling dozens of browser tabs, you keep everything in one place — making research, ordering and quality checking far easier.",

  "qc.title": "QC Photos & Quality Guide",
  "qc.body": "Quality control photos let you inspect an item before it ships. A good spreadsheet tracks QC photo links, measurements and any defects, so you can confirm the product matches the listing before paying for international shipping.",

  "shipping.title": "AllChinaBuy Shipping Cost Guide",
  "shipping.body": "Shipping cost depends on package weight, volume and the shipping line you choose. A well-structured spreadsheet records estimated weight, line options and final cost for each haul, helping you plan a budget and pick the most economical route to your country.",

  "review.title": "AllChinaBuy Review & Trust",
  "review.body": "We summarize real experiences, pros and cons, shipping timelines and customer support quality. Always verify current terms and policies on the official AllChinaBuy platform before making decisions.",

  "safety.title": "Safety Center",
  "safety.body": "Avoid fake spreadsheets and suspicious links. Only use trusted sources, verify sellers, understand customs and tax rules, and never share payment details outside official channels.",

  "articles.title": "Latest Guides & Articles",
  "articles.subtitle": "Original, in-depth SEO guides written around the AllChinaBuy spreadsheet theme.",
  "articles.card.title": "AllChinaBuy Spreadsheet: The Complete 2026 Guide",
  "articles.card.excerpt": "Learn what an AllChinaBuy spreadsheet is, how to use it for product research and QC, what shipping really costs, and whether AllChinaBuy is safe and legit.",
  "articles.card.readMore": "Read the Guide",
  "articles.card.meta": "Guide · 8 min read",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "Is AllChinaBuy legitimate?",
  "faq.a1": "AllChinaBuy is a well-known shopping agent. Always use the official website and verify policies before ordering. This independent site is not the official platform.",
  "faq.q2": "How much does AllChinaBuy shipping cost?",
  "faq.a2": "Shipping cost depends on weight, volume and the line you choose. Lighter, smaller parcels and economy lines usually cost less.",
  "faq.q3": "What is an AllChinaBuy spreadsheet?",
  "faq.a3": "It is a shared sheet that organizes product links, prices, QC photos and shipping notes for the items in your haul.",
  "faq.q4": "Does AllChinaBuy offer QC photos?",
  "faq.a4": "Yes, QC photos are available for many orders so you can inspect items before they ship internationally.",
  "faq.q5": "How do I find AllChinaBuy coupons or discount codes?",
  "faq.a5": "Check the official site and trusted communities for current offers. We do not publish unverified coupons or promotions.",

  "final.title": "Ready to Explore the AllChinaBuy Spreadsheet?",
  "final.subtitle": "Open the full spreadsheet to browse products, check QC photos and plan your next haul.",
  "final.button": "Open AllChinaBuy Spreadsheet",

  "footer.disclaimer": "AllChinaBuySpread.uk is an independent informational resource and is not the official AllChinaBuy website. Information may change. Verify current prices, promotions, shipping rules and policies before making decisions.",
  "footer.rights": "All rights reserved.",
  "footer.guide": "Spreadsheet Guide",
  "footer.home": "Home",
}